module.exports = __webpack_public_path__ + "img/bg.f1b14326.png";